import { render, staticRenderFns } from "./ListLabs.vue?vue&type=template&id=a53bebbc&"
import script from "./ListLabs.vue?vue&type=script&lang=js&"
export * from "./ListLabs.vue?vue&type=script&lang=js&"
import style0 from "./ListLabs.vue?vue&type=style&index=0&id=a53bebbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports